<template>
  <div class="content-box">
    <HconTitle subTitle="공지사항" subDescription="Hcon 새로운 소식과 다양한 혜택을 안내해 드립니다." />
    <div class="sub-wrapper block">
      <!-- tab title s -->
      <div class="tab-area v1">
        <ul class="tab-list">
          <li v-for="(item, idx) in announcement.v1.items" 
            :key="idx"
            class="tab-item" 
            :class="{ active: announcement.v1.activeIndex === idx }">
            <button class="tab-btn" @click="handleTabClick('v1', idx)">
              <span class="tab-text">{{ item.text }}</span>
            </button>
          </li>
        </ul>
      </div>
      <!-- tab title e -->
      <!-- tab pannel s -->
      <div class="tab-wrap">
        <div class="tab-pannel">
          <div class="mt80 ta-c">
            <div class="form-box inline-block w-auto">
              <div class="form-group row">
                <HconInput type="search" label="검색어" v-model="ntcTitle" :hide-label="false" labelClass="mn-wd60 fs16 ta-l" inpWrapClass="wd400" inputClass="lg" placeholder="제목으로 검색해주세요." @searchBtnClick="handleSearch" />
              </div>
            </div>
          </div>
          <div class="contents-title-wrap mt40 button">
            <div class="contents-title">
              <h4 class="font-bold">{{ getCurrentTabLabel }} 검색결과 <span class="text-green">{{ totalData }}</span>건</h4>
            </div>
            <div class="rgt-area">
              <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
            </div>
          </div>
          <div class="table-box notice">
            <table class="tbl-type">
              <caption>공지사항 관련 내역</caption>
              <colgroup>
                <col style="width:6%;">
                <col style="width:5%;">
                <col />
                <col style="width:10%;">
                <col style="width:7%;">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" class="small">No</th>
                  <th scope="col" class="small">분류</th>
                  <th scope="col" class="small">제목</th>
                  <th scope="col" class="small">등록일</th>
                  <th scope="col" class="small">조회수</th>
                </tr>
              </thead>
              <tbody v-if="noticeList.length > 0">
                <tr v-for="(data, index) in noticeList" :key="index" :class="{'has-top': data.isTop}">
                  <td class="medium number">{{ data.no }}</td>
                  <td class="medium cate">{{ data.cate }}</td>
                  <td class="medium left title">
                    <NuxtLink :to="String(data.link)" class="link-underline">{{ data.title }}</NuxtLink>
                  </td>
                  <td class="medium">{{ HconCommonUtils.format.date(data.regDate) }}</td>
                  <td class="medium">{{ data.views }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" class="nodata">검색 결과가 없습니다.</td>
                </tr>
              </tbody>
            </table>
            <HconPagination :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination"/>
          </div>
        </div>
      </div>
      <!-- tab pannel e -->        
    </div>
  </div>
</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue';
import HconPagination from '@/components/com/HconComPCPagination.vue';
import type { Notice } from '@/types/notice/backend-dto-types'

const fetchBuilder  = useHconFetchBuilder();
const ntcList = ref<Notice[]>([]);
const ntcTitle = ref('');
const {
  showAlert,
  showConfirm,
} = usePopup();

// 탭
const announcement = ref({
  v1: {
    items: [
        { text: '전체', value: ''},
        { text: '공지', value: '1001'},
        { text: '상품', value: '1002'}
    ],
    activeIndex: 0
  }
});

//탭 유형 
type TabVersion = 'v1';

const getCurrentTabLabel = computed(() => {
  const labels = ['전체', '공지', '상품'];
  return labels[announcement.value.v1.activeIndex];
})

// 탭 클릭 핸들러
const handleTabClick = (version: TabVersion, index: number) => {
  announcement.value[version].activeIndex = index;
  currentPage.value = 1; // 탭 변경시 1페이지로 리셋
  getNtcList();
};

// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20);  // 페이징 건수 : default - 20개씩 보기
const totalData   = ref<number>(0);  // 총 데이터 건수
const topCount    = ref<number>(0);

const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if (ntcList.value.length === 0) return 0;

  // TOP 공지 제외한 실제 데이터 개수로 페이지 계산
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getNtcList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getNtcList();
  }
})

const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

const searchParams = computed(() => {
  // 첫 페이지면 TOP 공지 개수만큼 추가로 요청
  const pageSize = currentPage.value === 1 ? 
    rowPerPage.value : 
    rowPerPage.value;
  
  return {
    hcNtcTypCd: announcement.value.v1.items[announcement.value.v1.activeIndex].value,
    ntcTitle: ntcTitle.value,
    pageNum: currentPage.value,
    pageSize: pageSize
  };
});

const getNtcList = async () => {
  ntcList.value = []; // No 계산 초기화
  fetchBuilder.get<TableDataInfo<Notice>>('/api/v1/notice/list')
    .query(searchParams.value)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
        ntcList.value = [];
        totalData.value = 0;
      } else {
        // ref 형식 변수에 값 즉시 세팅
        ntcList.value = result.data || [];
        topCount.value = ntcList.value.filter(item => item.ntcTopYn === 'Y').length;
        // 페이지네이션 처리
        totalData.value = result.total || 0;
      }
  });
}

// 검색
const handleSearch = () => {
  // 검색 시 1페이지로 리셋
  currentPage.value = 1;
  getNtcList();
}

// 공지사항 타입
interface NoticeData {
  ntcId?: number,
  no?: number | string,
  isTop?: boolean,
  cate: string,
  title: string,
  link: string,
  regDate: string,
  views: string
}

const noticeList = computed<NoticeData[]>(() => {
  let normalIndex = 0;
  const mapped = ntcList.value.map((item) => {
    return {
      ntcId: item.ntcId,
      isTop: item.ntcTopYn === 'Y',
      cate: item.hcNtcTypCd,
      title: item.ntcTitle,
      link: `/pc/notice/detail/${item.ntcId}?tab=${announcement.value.v1.items[announcement.value.v1.activeIndex].value}`,
      regDate: item.ntcRegDt,
      views: item.viewCount.toString()
    };
  });
  return mapped.map((item) => {
    if (item.isTop) return { ...item, no: 'TOP'};
    normalIndex++;
    return {
      ...item,
      no: totalData.value - topCount.value - (currentPage.value - 1) * rowPerPage.value - (normalIndex - 1)
    }
  })
});

onMounted(() => {
  getNtcList();
});

// 조건 변경 시 자동으로 재조회
// watch(searchParams, getNtcList, { deep: true });

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/cs-hcon.scss" as *;
</style>